/*!
 * Ajaxinate v2.0.1 (Fixed)
 * Copyright (c) 2019 Seth Hall <hello@setiahall.com>
 * Licensed under MIT
 */

;(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory)
  } else if (typeof exports === 'object') {
    module.exports = factory()
  } else {
    root.Ajaxinate = factory()
  }
}(this, function () {
  'use strict'

  var Ajaxinate = function (options) {
    var settings = options || {}
    this.method = settings.method || 'scroll'
    this.container = document.querySelector(settings.container) || document.querySelector('#AjaxinateContainer')
    this.pagination = document.querySelector(settings.pagination) || document.querySelector('#AjaxinatePagination')
    this.offset = settings.offset || 0
    this.loadingClass = settings.loadingClass || 'ajaxinate-is-loading'
    this.isLoading = false

    // Bind handlers once to preserve their references
    this.boundCheckPosition = this.checkPosition.bind(this)
    this.boundClickLimit = this.clickLimit.bind(this)
    
    if (this.container && this.pagination) {
      this.initialize()
    }
  }

  Ajaxinate.prototype.initialize = function () {
    var fragment = this.pagination.querySelector('a')
    
    if (fragment) {
      if (this.method === 'scroll') {
        window.addEventListener('scroll', this.boundCheckPosition)
        window.addEventListener('resize', this.boundCheckPosition)
        window.addEventListener('orientationchange', this.boundCheckPosition)
      } else if (this.method === 'click') {
        fragment.addEventListener('click', this.boundClickLimit)
      }
    } else {
      // No more pages left! Remove pagination element entirely.
      this.pagination.remove()
    }
  }

  Ajaxinate.prototype.removeListeners = function () {
    window.removeEventListener('scroll', this.boundCheckPosition)
    window.removeEventListener('resize', this.boundCheckPosition)
    window.removeEventListener('orientationchange', this.boundCheckPosition)
  }

  Ajaxinate.prototype.checkPosition = function () {
    if (this.isLoading) return

    var fragment = this.pagination.querySelector('a')
    
    if (fragment) {
      var rect = this.container.getBoundingClientRect()
      var bottom = rect.bottom - window.innerHeight
      
      if (bottom <= this.offset) {
        this.loadMore(fragment)
      }
    } else {
      this.removeListeners()
    }
  }

  Ajaxinate.prototype.clickLimit = function (e) {
    e.preventDefault()
    if (this.isLoading) return
    
    var fragment = this.pagination.querySelector('a')
    if (fragment) {
      this.loadMore(fragment)
    }
  }

  Ajaxinate.prototype.loadMore = function (fragment) {
    var path = fragment.href
    this.isLoading = true

    this.removeListeners()
    this.pagination.classList.add(this.loadingClass)
    
    var request = new XMLHttpRequest()
    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        if (request.status === 200) {
          var newDocument = new DOMParser().parseFromString(request.responseText, 'text/html')
          var newContainer = newDocument.querySelector('#AjaxinateContainer')
          var newPagination = newDocument.querySelector('#AjaxinatePagination')
          
          if (newContainer) {
            this.container.insertAdjacentHTML('beforeend', newContainer.innerHTML)
          }

          if (newPagination && newPagination.querySelector('a')) {
            this.pagination.innerHTML = newPagination.innerHTML
            this.pagination.classList.remove(this.loadingClass)
            this.isLoading = false
            this.initialize()
          } else {
            // If the new page doesn't have a pagination link, remove pagination and stop
            this.pagination.remove()
          }
        } else {
          this.isLoading = false
          this.pagination.classList.remove(this.loadingClass)
        }
      }
    }.bind(this)
    
    request.open('GET', path, true)
    request.send()
  }

  return Ajaxinate
}));